"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFromCartCB = exports.removeFromCart = void 0;
var queue_1 = require("./queue");
var events_1 = require("./events");
var jquery_1 = require("../jquery");
//Promise based
var removeFromCart = function (line) {
    return new Promise(function (resolve, reject) {
        (0, exports.removeFromCartCB)(line, resolve, reject);
    });
};
exports.removeFromCart = removeFromCart;
var removeFromCartCB = function (line, callback, errorCallback) {
    var o = {
        line: line,
        callback: callback,
        errorCallback: errorCallback,
        url: '/cart/change.js',
        dataType: 'json',
        method: 'POST',
        data: {
            line: line,
            quantity: 0
        },
        action: 'remove'
    };
    o.success = function (data) {
        if (this.callback)
            this.callback(data);
        (0, queue_1.addFinishTrigger)({ event: events_1.ON_ITEM_REMOVED, data: data });
        (0, queue_1.removeTask)(this);
        (0, queue_1.nextTask)();
    }.bind(o);
    o.error = function (e, i, a) {
        if (typeof this.errorCallback === "function") {
            this.errorCallback(e ? e.responseJSON || e : 'Unknown Error');
        }
        (0, queue_1.removeTask)(this);
        (0, queue_1.errorQueue)();
    }.bind(o);
    o.task = function () {
        jquery_1.jq.ajax(this);
    }.bind(o);
    (0, queue_1.addTask)(o);
};
exports.removeFromCartCB = removeFromCartCB;
//# sourceMappingURL=remove.js.map